// [BD feat] Collection mobile — insert testimonials marquee after N products
// Moves the marquee Shopify section into #product-grid on mobile only.
// Desktop keeps template order. Restores before filter swaps so the node
// is not destroyed with results.innerHTML.
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 989.98px)');
  var ATTR = 'data-bd-collection-mobile-after';
  var HOST_ATTR = 'data-bd-marquee-host';
  var SLOT_CLASS = 'bd-pdp-testimonials-marquee-section--in-grid';

  function isCollection() {
    return document.body && document.body.classList.contains('template-collection');
  }

  function hostFor(inner) {
    return (inner && inner.closest('.shopify-section')) || inner;
  }

  function productItems(grid) {
    return Array.prototype.slice.call(
      grid.querySelectorAll(':scope > .collection__grid__item')
    );
  }

  function ensureAnchor(host) {
    if (host._bdMarqueeAnchor && host._bdMarqueeAnchor.parentNode) {
      return host._bdMarqueeAnchor;
    }
    var anchor = document.createComment('bd-collection-marquee-anchor');
    if (host.parentNode) {
      host.parentNode.insertBefore(anchor, host);
    }
    host._bdMarqueeAnchor = anchor;
    return anchor;
  }

  function restore(host) {
    if (!host) return;
    var anchor = host._bdMarqueeAnchor;
    host.classList.remove(SLOT_CLASS);
    host.removeAttribute(HOST_ATTR);
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(host, anchor);
    }
  }

  function insert(host, afterCount) {
    var grid = document.querySelector(
      '.bd-collection-grid [data-bd-product-grid], .bd-collection-grid #product-grid'
    );
    if (!grid || !host) return;

    ensureAnchor(host);

    var items = productItems(grid);
    if (!items.length) {
      restore(host);
      return;
    }

    var index = Math.min(Math.max(afterCount, 1), items.length) - 1;
    var target = items[index];
    if (!target) {
      restore(host);
      return;
    }

    // Already correctly placed
    if (host.parentNode === grid && host.previousElementSibling === target) {
      host.classList.add(SLOT_CLASS);
      host.setAttribute(HOST_ATTR, 'true');
      return;
    }

    if (target.nextSibling) {
      grid.insertBefore(host, target.nextSibling);
    } else {
      grid.appendChild(host);
    }
    host.classList.add(SLOT_CLASS);
    host.setAttribute(HOST_ATTR, 'true');
  }

  function syncOne(inner) {
    var raw = parseInt(inner.getAttribute(ATTR), 10);
    if (!raw || raw < 1) return;

    var host = hostFor(inner);
    if (!host) return;

    if (MQ.matches) {
      insert(host, raw);
    } else {
      restore(host);
    }
  }

  function syncAll() {
    if (!isCollection()) return;
    var nodes = document.querySelectorAll('[' + ATTR + ']');
    Array.prototype.forEach.call(nodes, syncOne);
  }

  function restoreAll() {
    var hosts = document.querySelectorAll('.' + SLOT_CLASS + ', [' + HOST_ATTR + '="true"]');
    Array.prototype.forEach.call(hosts, restore);
    // Also restore any host that still has an anchor but lost the class
    var inners = document.querySelectorAll('[' + ATTR + ']');
    Array.prototype.forEach.call(inners, function (inner) {
      var host = hostFor(inner);
      if (host && host._bdMarqueeAnchor) restore(host);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(syncAll);

  if (MQ.addEventListener) {
    MQ.addEventListener('change', syncAll);
  } else if (MQ.addListener) {
    MQ.addListener(syncAll);
  }

  // Filter is about to wipe results HTML — pull marquee out first
  document.addEventListener('bd:collection-filter:before-swap', restoreAll);
  document.addEventListener('bd:collection-filter:swapped', function () {
    window.requestAnimationFrame(syncAll);
  });
  document.addEventListener('bd:collection-infinite:appended', function () {
    window.requestAnimationFrame(syncAll);
  });

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(syncAll);
  });

  // Public hook if other scripts need a re-check
  document.addEventListener('bd:collection-marquee:sync', syncAll);
})();
// [BD feat] Collection mobile marquee insert
